import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Comment } from '@shared/models/icommons.model';
import { HttpMethods } from '@cbre/http';

const conversationUrl = (type: string, conversationId: string) => `/notes/${type}/${conversationId}`;

@Injectable({
  providedIn: 'root',
})
export class CommentsApiService {
  constructor(private http: HttpMethods) {}

  create(type: string, conversationId: string, comment: Comment) {
    return this.http.httpPost(`${conversationUrl(type, conversationId)}`, comment);
  }

  update(type: string, conversationId: string, { id, message }: Comment) {
    return this.http.httpPut(`${conversationUrl(type, conversationId)}/${id}`, { message });
  }

  delete(type: string, conversationId: string, { id }: Comment) {
    return this.http.httpDelete(`${conversationUrl(type, conversationId)}/${id}`);
  }

  getConversation(type: string, conversationId: string): Observable<Comment[]> {
    return <Observable<Comment[]>>this.http.httpGet(`${conversationUrl(type, conversationId)}`);
  }
}
